import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';

import { InputProps } from '../props';

interface ComponentProps extends InputProps {
  minDate?: string | Dayjs;
  maxDate?: string | Dayjs;
}

// HTML input type="month" uses YYYY-MM format
const monthInputFieldFormat = 'YYYY-MM';

const MonthInput: React.FC<ComponentProps> = ({
  id,
  value,
  placeholder,
  disabled = false,
  className,
  onChange,
  name,
  dataCy = null,
  minDate,
  maxDate,
}) => {
  const monthValue = value ? dayjs(value, monthInputFieldFormat) : null;

  const setChange = (value: Dayjs | null) => {
    onChange && onChange(id, value ? value.format(monthInputFieldFormat) : null);
  };

  const monthClass = classNames('form-control', {
    [`${className}`]: className != undefined,
  });

  let dataCyId = `${id}-month`;
  if (dataCy) dataCyId = `${dataCy}-${dataCyId}`;

  return (
    <DatePicker
      value={monthValue}
      disabled={disabled}
      label={placeholder}
      name={name}
      views={['month', 'year']}
      format="MMMM YYYY"
      className={monthClass}
      minDate={minDate ? dayjs(minDate, monthInputFieldFormat) : undefined}
      maxDate={maxDate ? dayjs(maxDate, monthInputFieldFormat) : undefined}
      slotProps={{
        field: { shouldRespectLeadingZeros: true },
        textField: {
          inputProps: { 'data-cy': dataCyId },
          size: 'small',
        },
        actionBar: { actions: ['clear', 'today'] },
      }}
      onChange={(value) => setChange(value)}
    />
  );
};

export default MonthInput;
